import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef, Children } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from './SnackbarQueue.module.scss.js';

const { componentTestLabel } = getTestLabels('SnackbarQueue');
/**
 * [design (Figma)](https://www.figma.com/design/MUnGlxUUspXSbRkFsEXWGQ/%F0%9F%92%A0-Core-Components?node-id=8604-59106&node-type=section&t=EDysr1f69m8d1p4V-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Snackbar/Snackbar.tsx)
 *
 * @param {string} bottomOffset - (optional) A CSS distance unit to override the bottom screen offset (useful for repositioning the snackbar queue when the scroll-to-top button is visible.
 */
const SnackbarQueue = forwardRef((props, ref) => {
    const { bottomOffset, children } = props;
    return (jsx("div", { "data-zta": componentTestLabel, ref: ref, className: classNames(style['z-snackbar-queue'], {
            [style['z-snackbar-queue--empty']]: Children.count(children) < 1,
        }), style: bottomOffset ? { bottom: bottomOffset } : {}, children: children }));
});
SnackbarQueue.displayName = 'SnackbarQueue';

export { SnackbarQueue };
//# sourceMappingURL=SnackbarQueue.js.map
